import { useState } from "react";
// import CommunityBarChart from "../../sharedPages/MarketPlace/CommunityBarChart";
import CommunityAreaChart from "../../sharedPages/MarketPlace/CommunityAreaChart";


function TradingGraphPnl({ user, activeButton, pnlPercentage, thisWeekPnlPercentage, activeTab, onTabChange, market }) {

  return (
    <div className="TradingBox d-flex flex-column p-0 pt-3 m-0">

      <div className="chartBox p-0">
        {/* <CommunityBarChart
          duration={activeButton}
          graphType="pnl"
          userId={user?._id}
        /> */}
        <CommunityAreaChart
          bare
          graphType="pnl"
          userId={user?._id}
          activeTab={activeTab}
          onTabChange={onTabChange}
          market={market}
        />
      </div>
    </div>
  );
}

export default TradingGraphPnl;

